/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import ProfileIcon from 'components/ProfileIcon';
import Button from 'components/Button';
import Textarea from 'components/Textarea';
import SingleDot from 'assets/icons/single-dot';
import { CommentSectionContainer, CommentAligmentItems, CommentAligmentButtons } from './style';
import ReadMore from 'components/ReadMore';
import ActionsMenu from 'features/ActionMenu';
import EditIcon from 'assets/icons/edit-icon';
import RemoveIcon from 'assets/icons/remove-icon';
import CheckIcon from 'assets/icons/check-icon';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import { removeCommentById, requestGetReplyCopy, resolveCommentById, reactivateCommentById } from 'api/site';
import { SiteContext } from 'providers/site';
import UpdateForm from 'flow/SiteProposal/components/Comments/UpdateForm/updateForm';
import RepliesList from 'flow/SiteProposal/components/Comments/RepliesList/RepliesList';
import Modal from 'components/Modal';
import RemoveCommentModal from 'flow/SiteProposal/components/Comments/RemoveCommentModal/RemoveCommentModal';
import { useParams } from 'react-router-dom';
import { ProfileContext } from 'providers/profile';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { editOnly } from 'routing/constants';
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses';

const CommentItem = ({
  profile,
  text = "",
  countReplies,
  createdAt,
  updatedAt,
  commentId,
  getCommentsData,
  isResolved: initialIsResolved,
}) => {
  const params = useParams();
  const [replyState, setReplyState] = useState("hide");
  const [isPressedEditComment, setIsPressedEditComment] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [repliesList, setRepliesList] = useState([]);
  const [isResolved, setIsResolved] = useState(initialIsResolved);
  const [canEdit, setCanEdit] = useState(!initialIsResolved);
  const { site } = useContext(SiteContext);
  const { profile: loggedInProfile } = useContext(ProfileContext);
  const dateCreated = Date.parse(createdAt);
  const dateUpdated = Date.parse(updatedAt);

  const editOnlySite = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null;
  const editOnlySiteStatus = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID;
  const historyId = editOnlySiteStatus ? site.sitehistoryId : params.siteHistoryId;

  TimeAgo.addDefaultLocale(en);
  const ago = new TimeAgo("en-US");
  const time = ago.format(new Date(dateUpdated));

  const isRfpOrSecretariat = loggedInProfile?.Role?.id && [3, 4].includes(loggedInProfile.Role.id);
  const isMyComment = profile.id === loggedInProfile?.id;

  const deleteComment = async () => {
    try {
      await removeCommentById(site.id, commentId, historyId, editOnlySite);
      getCommentsData();
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  const resolveComment = async () => {
    try {
      await resolveCommentById(site.id, commentId, historyId, editOnlySite);
      setIsResolved(true);
      setCanEdit(false);
      setIsPressedEditComment(false);
      getCommentsData();
    } catch (error) {
      console.error("Error resolving comment:", error);
    }
  };

  const reactivateCommentEditing = async () => {
    try {
      await reactivateCommentById(site.id, commentId, historyId, editOnlySite);
      setIsResolved(false);
      setCanEdit(true);
      getCommentsData();
    } catch (error) {
      console.error("Error reactivating comment editing:", error);
    }
  };

  const replyComment = () => {
    if (replyState === 'add') return;
    setReplyState('add');
  };

  const handleReplyList = async () => {
    if (replyState === "hide") {
      setReplyState("show");
      try {
        const data = await requestGetReplyCopy(site.id, commentId, historyId, {}, editOnlySite);
        setRepliesList(data);
      } catch (error) {
        console.error("Error fetching replies:", error);
      }
    } else {
      setReplyState("hide");
    }
  };

  const getReplyData = async () => {
    try {
      const data = await requestGetReplyCopy(site.id, commentId, historyId, {}, editOnlySite);
      setRepliesList(data);
    } catch (error) {
      console.error("Error fetching replies:", error);
    }
  };

  const dropdownItems = [
    isMyComment && canEdit && {
      icon: <EditIcon />,
      title: "Edit Comment",
      onClick: () => setIsPressedEditComment((state) => !state),
    },
    isMyComment && {
      icon: <RemoveIcon />,
      title: "Remove Comment",
      onClick: () => setIsOpen(true),
    },
    isResolved && isRfpOrSecretariat && {
      icon: <AutorenewIcon />,
      title: "Activate Thread",
      onClick: reactivateCommentEditing,
    },
    isRfpOrSecretariat && {
      icon: <CheckIcon />,
      title: "Resolve Comment",
      onClick: resolveComment,
    },
  ].filter(Boolean);

  useEffect(() => {
    getReplyData();
  }, []);

  return (
    <CommentSectionContainer isResolved={isResolved}>
      <div
        style={{
          textAlign: "left",
          marginBottom: "10px",
          color: "rgba(10,161,244,1)",
          fontWeight: "bold",
        }}
      >
        {profile.commentCategory}
      </div>

      <CommentAligmentItems>
        <div style={{ display: "flex", alignItems: "center" }}>
          <ProfileIcon user={profile} isInCommentSection />
          <div
            style={{
              display: "flex",
              padding: "0 13px",
              alignItems: "center",
            }}
          >
            <SingleDot />
            <div
              style={{ paddingLeft: "13px", color: "rgba(32, 32, 32, 0.7)" }}
            >
              {dateUpdated === dateCreated ? time : `${time} (edited)`}
            </div>
          </div>
        </div>
        <ActionsMenu dropdownItems={dropdownItems} />
      </CommentAligmentItems>

      {isResolved && (
        <p style={{ color: "green" }}>
          <i>This comment has been resolved.</i>
        </p>
      )}

      <Modal
        isOpen={isOpen}
        toggleModal={setIsOpen}
        modalTitleId="removeComment"
        label="leaveComment"
        padding="8px"
        bottomBorder={false}
        paddingBottom="0"
        justifyContent="center"
      >
        <RemoveCommentModal
          closeModal={() => setIsOpen(false)}
          confirmRemove={deleteComment}
        />
      </Modal>

      {!isPressedEditComment ? (
        <ReadMore text={text} maxLength={240} />
      ) : (
        <UpdateForm
          setEditComment={setIsPressedEditComment}
          getCommentsData={getCommentsData}
          commentId={commentId}
          text={text}
        />
      )}

      <CommentAligmentButtons>
        {!isResolved && (
          <>
            <Button marginTop="0" type="replyComments" onClick={replyComment}>
              Reply
            </Button>
            <Button marginTop="0" type="replyComments" onClick={handleReplyList}>
              {replyState === 'hide' ? 'Show Replies' : 'Hide Replies'}
            </Button>
          </>
        )}
      </CommentAligmentButtons>
      {!isResolved && replyState === 'show' && (
        <RepliesList commentData={repliesList} getReplyData={getReplyData} getCommentsData={getCommentsData} />
      )}
      {!isResolved && replyState === 'add' && (
        <RepliesList
          commentData={repliesList}
          getReplyData={getReplyData}
          replyState={replyState}
          setReplyState={setReplyState}
          commentId={commentId}
          replyText={`Replying to @${profile.firstName} ${profile.lastName}`}
          getCommentsData={getCommentsData}
        />
      )}
      {!isResolved && replyState === 'show' && repliesList.length === 0 && <p>No replies</p>}
    </CommentSectionContainer>
  );
};

export default CommentItem;
